import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository'
import { DashboardDiagnosticTriggerRequest } from '@/core/domain/dashboard/DashboardDiagnosticTriggerRequest'
import type { DashboardClassroomDiagnosticTrigger } from '@/core/domain/dashboard/DashboardClassroomDiagnosticTrigger'

/**
 * Use case pour déclencher un diagnostic T1 (start)
 */
export class TriggerDiagnosticStartUseCase {
  private readonly dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    classroomId: number,
    schoolClassroomId: number
  ): Promise<DashboardClassroomDiagnosticTrigger[]> {
    const triggerRequest = DashboardDiagnosticTriggerRequest.create({
      schoolClassroomId,
      triggerTime: new Date().toISOString()
    })

    return await this.dashboardRepository.triggerDiagnosticStart(classroomId, triggerRequest)
  }
}
